export const getCleanUrl = (params: URLSearchParams) => {
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  const cleanUrl = newUrl.endsWith('?') ? newUrl.slice(0, -1) : newUrl;
  return cleanUrl;
};
